import { render, staticRenderFns } from "./NewIssuePopup.vue?vue&type=template&id=edfb00f8&scoped=true"
import script from "./NewIssuePopup.vue?vue&type=script&lang=js"
export * from "./NewIssuePopup.vue?vue&type=script&lang=js"
import style0 from "./NewIssuePopup.vue?vue&type=style&index=0&id=edfb00f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfb00f8",
  null
  
)

export default component.exports